<template>
	<div style="position: relative;">
		<el-form label-width="80px" :model="contentModel">
			<el-form-item label="分类" v-if="type!='news'">
				<el-select v-model="contentModel.class_id" placeholder="请选择">
					<el-option v-for="item in classifysOption" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="标题">
				<el-input v-model="contentModel.title"></el-input>
			</el-form-item>
			<el-form-item label="关键词">
				<el-input v-model="contentModel.keywords"></el-input>
			</el-form-item>
			<el-form-item label="描述">
				<el-input type="textarea" v-model="contentModel.description"></el-input>
			</el-form-item>
			<el-form-item label="时间">
				<el-date-picker v-model="contentModel.update_time" type="datetime" placeholder="选择日期时间">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="浏览量">
				<el-input type="number" v-model="contentModel.page_view"></el-input>
			</el-form-item>
			<el-form-item label="封面">
				<corpper ref="corpper" @uploadImgSuccess="uploadCover"></corpper>
				<div v-if="alreadyUp" style="text-align: right; font-size: 16px; color: #42B983;">封面已上传</div>
			</el-form-item>
		</el-form>
		<editor v-model="contentModel.content" ></editor>
		<!-- <editor v-model="contentModel.content" :isClear="isClear"></editor> -->
		<div style="display: flex;justify-content: flex-end; margin-top: 20px;">
			<el-button type="primary" @click="commit">{{contentModel.id?'修改':'添加'}}</el-button>
		</div>
		<el-button type="success" style="position: absolute; right: 0px; top: 0px;" @click="dialogVisible = true">预览
		</el-button>
		<el-dialog title="预览" :visible.sync="dialogVisible" width="100%" :fullscreen="true">
			<div v-html="contentModel.content"></div>
		</el-dialog>
	</div>
</template>
<script>
	import editor from '../../components/editor.vue'
	import corpper from '../../components/corpper.vue'
	import {
		classifys
	} from '../../api/classify.js'
	import {
		contentById,
		addContent,
		updateContent,
		uploadImg
	} from '../../api/content.js'
	import config from '../../config.js'
	export default {
		components: {
			editor,
			corpper
		},
		data() {
			return {
				isClear: false, //清除富文本编辑器内容
				classifysOption: [],
				contentModel: {},
				dialogVisible: false,
				alreadyUp: false,
				fileList: [],
				type: ''
			}
		},
		methods: {
			async commit() {
				if (this.contentModel.update_time) {
					this.contentModel.update_time = Number(new Date(this.contentModel.update_time))
				}
				this.classifysOption.forEach(e => {
					if (e.value == this.contentModel.class_id) {
						this.contentModel.class_name = e.label
					}
				})
				if (!this.contentModel.cover) {
					this.$message.warning('请先上传封面图片')
					return
				}
				this.contentModel.page_view = this.contentModel.page_view? this.contentModel.page_view:0
				if (this.contentModel.id) {
					await updateContent(this.contentModel)
					this.$message.success('修改成功')
				} else {
					await addContent(this.contentModel)
					// this.contentModel = {}
					this.$message.success('添加成功')
				}
				setTimeout(()=>{
					this.$router.push({
						path: "/content"
					})
				},800)
			},
			uploadCover(e) {
				this.contentModel.cover = e
				console.log(this.contentModel.cover)
				this.alreadyUp = true
				this.$message.success('上传封面成功')
			},
			beforeUp(e) {
				let formData = new FormData();
				formData.append('file', e)
				uploadImg(formData).then(res=>{
					this.fileList = [e]
					let baseUrlStr = config.baseURL.split('api/')[0]
					this.contentModel.down_url = baseUrlStr + 'public/uploads/' + res.data.filename
				})
				return false
			}
		},
		created() {
			this.type = this.$route.query.type
			classifys({
				pageNo: 1,
				pageSize: 100
			}).then(res => {
				this.classifysOption = res.data.data.map(e => {
					return {
						label: e.name,
						value: e.id
					}
				})
			})
			if (this.$route.query.id) {
				this.contentModel.id = this.$route.query.id
				contentById(this.contentModel.id).then(res => {
					this.contentModel = res.data
					this.$refs.corpper.setImg(this.contentModel.cover)
				})
			}
		}
	}
</script>
